// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2O9u3","vLegacy":"SelectSecondary_vLegacy__1guPd","error":"SelectSecondary_error__3hy6_","disabled":"SelectSecondary_disabled__zOxXV"};